import React from 'react';

/**
 * ModeTabs Component
 * 
 * Tab selector for switching between Link, Upload, and Select modes
 */
const ModeTabs = ({ 
  mode, 
  setMode, 
  isUploading 
}) => {
  return (
    <div className="deliverable-submit-modal__tabs">
      <button 
        className={`deliverable-submit-modal__tab ${mode === 'link' ? 'deliverable-submit-modal__tab--active' : ''}`}
        onClick={() => setMode('link')}
        disabled={isUploading}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
        Link
      </button>
      <button 
        className={`deliverable-submit-modal__tab ${mode === 'upload' ? 'deliverable-submit-modal__tab--active' : ''}`}
        onClick={() => setMode('upload')}
        disabled={isUploading}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        Upload
      </button>
      <button 
        className={`deliverable-submit-modal__tab ${mode === 'select' ? 'deliverable-submit-modal__tab--active' : ''}`}
        onClick={() => setMode('select')}
        disabled={isUploading}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
        Attachments
      </button>
    </div>
  );
};

export default ModeTabs;
